<template>
  <transition name="fade">
    <div class="ui-loading" v-show="showLoading">
      <div class="loading-content">
        <i class="icon-loading"></i>
        <span>{{ loadingDesc }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'uiLoading',
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      showLoading: 'loading/showLoading',
      loadingDesc: 'loading/loadingDesc'
    })
  }
}
</script>

<style lang="scss" scoped>
.ui-loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  .loading-content {
    height: 2.4rem;
    width: 2.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 0.26rem;
    color: #ffffff;
    text-align: center;
    background: rgba(17, 17, 17, 0.7);
    border-radius: 0.1rem;
    .icon-loading {
      margin-top: 0.5rem;
      margin-bottom: 0.36rem;
      width: 0.92rem;
      height: 0.92rem;
      background: url("../../assets/images/icon_loading.svg") no-repeat center;
      background-size: 100%;
    }
  }
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-in-out 0.2s;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
</style>
